import useAvailableDates from './useAvailableDates';

const useYesterdayDate = (): string => {
  const { data } = useAvailableDates();
  return data!.to;
};

export default useYesterdayDate;
